export default __webpack_public_path__ + "static/media/brand_bg01.1dbaa746.png";